import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BeingCheckedComponent } from './being-checked.component';


const routes: Routes = [
  {
    path: '',
    component: BeingCheckedComponent,
    data: {
      title: "Ariza holati",
      breadcrumb: "Ariza holati"
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BeingCheckedRoutingModule { }
